module.exports = __webpack_public_path__ + "static/media/_scotland.6bcc2108.png";